import { Injectable } from '@angular/core';

import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IException } from '@shared/interfaces';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                // if (event instanceof HttpResponse) {
                //     console.log('event--->>>', event);
                // }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    return throwError(error);
                }

                if (error.status > 0) {
                    const gkError: IException = error.error as IException;

                    if (gkError.IsGatekeeperError) {
                        // console.log('show no message');
                        return throwError(gkError);
                    }
                    else {
                        // console.log('show error dialog');
                        return throwError(gkError);
                    }
                }
                else {
                    // unknown error - most likely server not available
                    return throwError({
                        Guid: 'No Guid',
                        IsGatekeeperError: false,
                        Message: error.message,
                        Type: 'Unknown',
                        TypeName: 'Unknown'
                    } as IException);
                }
            }));
    }
}
